import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from './congratulationsScreen.module.css'
import { useState } from 'react';
import CommonModalWrapper from '../../common-modal-Wrapper/CommonModalWrapper';
import AdsCategories from '../ads-categories/AdsCategories';
import CloseIcon from '../../Icons/CloseIcon';



export default function CongratulationsScreen({ cong, toggleModalVisibilty = () => { } }) {
  const [modalIsModalForPostAdsCategries, updateModalIsModalForPostAdsCategries] = useState(false);
  const navigate = useNavigate();


  // const toggleModalForPostAdscategories = (toggleValue = false) => {
  //   console.log('Toggle Post Ads Categories Modal:', toggleValue);

  //   window.location = `/?postadd=true`;
  //   if (toggleValue) {
  //     document.body.classList.add('body-fixed');
  //     updateModalIsModalForPostAdsCategries(true);
  //     toggleModalVisibilty(false);

  //     const closeIcon = document.querySelector('.styles_close_icon_wrapper__V0ZFv');
  //     if (closeIcon) {
  //       closeIcon.click();
  //     }
  //   } else {
  //     document.body.classList.remove('body-fixed');
  //     updateModalIsModalForPostAdsCategries(false);
  //     toggleModalVisibilty(true);
  //   }
  // };


  const toggleModalForPostAdscategories = (toggleValue = false) => {
    // console.log('Toggle Post Ads Categories Modal:', toggleValue);

    // Clear all ad-related data from localStorage
    // localStorage.removeItem('adsInfo');
    // localStorage.removeItem('advertisementId');
    // localStorage.removeItem('adsCategories');

    if (toggleValue) {
      document.body.classList.add('body-fixed');
      updateModalIsModalForPostAdsCategries(true);
      toggleModalVisibilty(false);

      // Redirect after clearing localStorage
      window.location.href = '/?postadd=true';
    } else {
      document.body.classList.remove('body-fixed');
      updateModalIsModalForPostAdsCategries(false);
      toggleModalVisibilty(true);
    }
  };

  const adsTypeToRoute = {
    rentals: "/rentalAds",
    "room-rents": "/rentalAds",
    jobs: "/jobsAds",
    events: "/eventsAds",
    BuyAndSell: "/buySellAds",
    BabbysitterAndNanny: "/babysitterAds",
    localbizANDservices: "/localBizAds"
  };

  const onClickGoToAds = (e) => {
    // Prevent default link behavior
    if (e) {
      e.preventDefault();
    }

    // console.log('=== Manage My Ads Clicked ===');
    // console.log('adsInfo from localStorage:', adsInfo);
    // console.log('adsType:', adsInfo?.adsType);
    toggleModalVisibilty(false);

    // if (!adsInfo?.adsType) {
    //   console.warn('No adsType found, navigating to home');
    //   navigate('/');
    //   return;
    // }
      if (!adsInfo?.adsType) {
    console.warn('No adsType found, navigating to home');
    window.location.href = '/';  // ✅ Use window.location.href
    return;
  }

    const route = adsTypeToRoute[adsInfo.adsType];
    // console.log('Mapped route:', route);

    if (route) {
      // console.log('Navigating to:', route);
      // navigate(route);
       window.location.href = route;
    } else {
      console.warn('No route mapping found for adsType:', adsInfo.adsType);
      // navigate('/');
      window.location.href = '/'; 
    }

    // console.log('=== Navigation Complete ===');
  };


  const adsInfoString = localStorage.getItem('adsInfo');
  const adsInfo = adsInfoString ? JSON.parse(adsInfoString) : null;

  const adsCategoriesString = localStorage.getItem('adsCategories');
  const adsCategories = adsCategoriesString ? adsCategoriesString : null;

  const advertisementId = localStorage.getItem('advertisementId');
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;

  function generateLink(adsType, id) {
    if (adsType === 'rentals') {
      return `rentDetails/${id}`;
    } else if (adsType === 'jobs') {
      return `jobDetails/${id}`;
    } else if (adsType === 'events') {
      return `eventDetails/${id}`;
    } else if (adsType === 'localbizANDservices') {
      return `localBizDetails/${id}`;
    } else if (adsType === 'BabbysitterAndNanny') {
      return `babySitterDetails/${id}`;
    } else if (adsType === 'BuyAndSell') {
      return `buySellDetails/${id}`;
    } else {
      return '';
    }
  }

  // function handleClick(adsType, id) {
  //   console.log('View Ad Link Clicked - adsType:', adsType, 'id:', id);

  //   const link = generateLink(adsType, id);
  //   console.log('Generated link:', link);

  //   if (link) {
  //     navigate(link);
  //   } else {
  //     console.warn('No link generated, reloading page');
  //     window.location.reload();
  //   }
  // }
  function handleClick(adsType, id) {
    // console.log('View Ad Link Clicked - adsType:', adsType, 'id:', id);

    const link = generateLink(adsType, id);
    // console.log('Generated link:', link);

    if (link) {
        // Use window.location.href instead of navigate
        window.location.href = `/${link}`;
    } else {
        console.warn('No link generated, reloading page');
        window.location.reload();
    }
}

  return (
    <>

      <main id='span-2' className={style.main_wrapper}>
        <section className={style.heading_section}>
          <svg width="150" height="150" viewBox="0 0 232 232" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="116" cy="116" r="115.753" fill="#FE4A49" fillOpacity="0.06" />
            <circle cx="116" cy="116" r="89" fill="#FE4A49" fillOpacity="0.12" />
            <path d="M178 118C178 134.178 171.573 149.694 160.134 161.134C148.694 172.573 133.178 179 117 179C100.822 179 85.3062 172.573 73.8665 161.134C62.4268 149.694 56 134.178 56 118C56 101.822 62.4268 86.3062 73.8665 74.8665C85.3062 63.4268 100.822 57 117 57C133.178 57 148.694 63.4268 160.134 74.8665C171.573 86.3062 178 101.822 178 118ZM147.729 94.8962C147.184 94.3535 146.536 93.9261 145.822 93.6398C145.108 93.3534 144.344 93.2139 143.576 93.2295C142.807 93.2452 142.049 93.4157 141.348 93.7309C140.646 94.0461 140.016 94.4995 139.494 95.064L113.012 128.805L97.053 112.838C95.9689 111.828 94.5351 111.278 93.0535 111.304C91.572 111.33 90.1584 111.93 89.1106 112.978C88.0629 114.026 87.4627 115.439 87.4365 116.921C87.4104 118.402 87.9603 119.836 88.9705 120.92L109.146 141.104C109.69 141.646 110.337 142.074 111.049 142.361C111.762 142.648 112.524 142.788 113.292 142.774C114.06 142.76 114.817 142.591 115.518 142.278C116.22 141.965 116.851 141.514 117.374 140.951L147.813 102.903C148.85 101.824 149.424 100.381 149.409 98.8838C149.395 97.3869 148.794 95.9552 147.736 94.8962H147.729Z" fill="#FD7E14" />
          </svg>

          <h3 className={style.heading}>Congratulations</h3>
          <p className={style.thanks_text}>
            Thank you for posting your Ad <span style={{ color: "Black" }}>"{(adsInfo?.title || adsCategories || 'Unnamed Ad')}"</span>
            (Ad Id: <span style={{ color: "Black" }}>{advertisementId || 'N/A'}</span>)
          </p>
          <p>We moderate listings in order to follow safety practices, which can sometimes take a few minutes. Once your Ad is approved, it will be available to
             <span onClick={(e) => { e.preventDefault(); handleClick(adsInfo.adsType, adsInfo.id); }} className={style.congratsLink} style={{ cursor: 'pointer' }}>view here</span>.</p>
          <p>We sent a confirmation email to <span style={{ fontWeight: 700, color: "black" }}>{user?.email_address || 'your email'}</span></p>
        </section>

        <section className={`button_wrapper`}>
          <div id="back_button" className="form-group"
            onClick={() => { toggleModalForPostAdscategories(true) }}>
            <p className="btn-confirm"> Post another ad </p>
          </div>

          <div id={style.submit_btn_wrapper} className="form-group" onClick={onClickGoToAds}>
            <button id={style.home_btn} type="button" className="btn btn-confirm">
              Manage my ads
            </button>
          </div>
        </section>
      </main>
    </>
  )
}